import { AxiosRequestConfig } from "axios";
import ClientConfig from "./clientConfig";

export default class ClientBase {
  private config: ClientConfig;

  constructor(config: ClientConfig) {
    this.config = config;
  }

  protected transformOptions = (options: AxiosRequestConfig) => {
    const newOptions = { ...options };

    newOptions.headers = {
      ...newOptions.headers,
      "X-CSRF": "1",
      ...(Boolean(this.config.getPartnerId().length) && {
        PartnerId: this.config.getPartnerId(),
      }),
    };

    newOptions.transformResponse = (data: unknown) => data;

    return Promise.resolve(newOptions);
  };
}
